import React from "react";
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Text,
  TextStyle,
  TouchableOpacity,
} from "react-native";
import { ChevronRightIcon } from "./components";
import { Icon, IconName } from "src/components";
import { colors } from "src/assets";

export type FormControlLabelProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  textStyle?: StyleProp<TextStyle>;
  helper?: string;
  helperStyle?: StyleProp<TextStyle>;
  detail?: string;
  detailStyle?: StyleProp<TextStyle>;
  detailRender?: React.ReactNode;
  rightIcon?: IconName;
  error?: string;
  onPress?: () => void;
};

export const FormControlLabel: React.FC<FormControlLabelProps> = ({
  containerStyle,
  text,
  textStyle,
  helper,
  helperStyle,
  detail,
  detailStyle,
  detailRender,
  rightIcon,
  error,
  onPress,
}) => {
  const content = () => {
    return (
      <React.Fragment>
        <View style={styles.content}>
          <View style={{ flexDirection: "column" }}>
            <Text style={[styles.text, textStyle]}>{text}</Text>
            {helper && (
              <Text style={[styles.helper, helperStyle]}>{helper}</Text>
            )}
          </View>
          {detailRender ? (
            <View style={styles.rightContainer}>{detailRender}</View>
          ) : (
            <View style={styles.rightContainer}>
              {detail ? (
                <Text style={[styles.detail, detailStyle]}>{detail}</Text>
              ) : null}
              {rightIcon === "chevron" ? (
                <ChevronRightIcon style={styles.rightIcon} />
              ) : null}
              {rightIcon && rightIcon !== "chevron" ? (
                <Icon
                  style={styles.rightIcon}
                  name={rightIcon}
                  color={"#A5A5A5"}
                  size={24}
                />
              ) : null}
            </View>
          )}
        </View>
        {error ? <Text style={styles.error}>{error}</Text> : null}
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      {onPress ? (
        <TouchableOpacity
          style={[styles.container, containerStyle]}
          onPress={onPress}
        >
          {content()}
        </TouchableOpacity>
      ) : (
        <View style={[styles.container, containerStyle]}>{content()}</View>
      )}
    </React.Fragment>
  );
};

export const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: colors.white,
    flexDirection: "column",
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    color: colors.chokuGray,
    fontSize: 14,
    marginRight: 16,
  },
  helper: {
    color: colors.chokuGray,
    fontSize: 10,
    marginRight: 16,
  },
  rightContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  detail: {
    color: colors.chokyGray10,
    fontSize: 14,
  },
  rightIcon: {
    marginLeft: 8,
  },
  error: {
    color: colors.chokuRed,
  },
});
